export default __webpack_public_path__ + "static/media/saint_aubin3.c51cf73a.jpg";